export interface displayValue {
  display: string;
  value: string;
}
export function getMonth() {
  const month = [];
  for (let i = 1; i < 13; i++) {
    month.push({
      display: i < 10 ? `0${i.toString()}` : i.toString(),
      value: i < 10 ? `0${i.toString()}` : i.toString(),
    });
  }
  return month;
}
